var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"1920px","height":"1080px","background":"#FFF","color":"#FFF"},attrs:{"id":"video"}})])
}]

export { render, staticRenderFns }